import { render } from "./InspectionPlan.vue?vue&type=template&id=37730d60"
import script from "./InspectionPlan.vue?vue&type=script&lang=js"
export * from "./InspectionPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__